import { Component } from "@angular/core";

@Component({
    selector: 'amazon-congratulation',
    templateUrl:'amazon-congratulation.component.html',
    moduleId: module.id.toString()
})
export class AmazonCongratulationComponent {
    
}


// WEBPACK FOOTER //
// ./app/components/amazon/congratulation/amazon-congratulation.component.ts